






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Deal } from '@/Deal'
import { TokenUser } from '@/TokenUser'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import { Plotly } from '@rleys/vue-plotly-basic'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'DealListComponent',
  components: { Plotly, ModalWrapperComponent }
})
export default class DealListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public deal: Deal

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get devMode(): boolean { return this.$store.state.devmode }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public getNiceFMVString(): string { return utils_topshot.getNicePossibleDecimalPriceStringForFMV(this.deal.valueFMV) }
  public getNicePriceString(): string { return utils_topshot.getNicePriceString(this.deal.price) }
  public getNicePossibleDecimalPriceString(): string { return utils_topshot.getNicePossibleDecimalPriceString(this.deal.price)}

  public showLedger(momentID: number, serial: number) {
    (this.$refs.MomentActivityFeedComponent as ModalWrapperComponent).show(`⏳ Serial #${serial} Timeline`, 'lg', { momentID: momentID })
  }

  public onBuyBid(deal: Deal) {
    if (deal.auction) {
      const dynamicProps: any = { auctionId: deal.auction.getIdAsString(), temporaryURL: deal.auction.getLiveTokenAuctionLink() };
      (this.$refs.AuctionComponent as ModalWrapperComponent).show('Loading auction details...', 'md', dynamicProps);
      return
    }
    const url: string = deal.getBuyURL()
    window.open(url, "_blank"); 
    this.sendDealClick(deal)
  }
  public onGone(deal: Deal) {
    if (deal.auction) {
      const dynamicProps: any = { auctionId: deal.auction.getIdAsString(), temporaryURL: deal.auction.getLiveTokenAuctionLink() };
      (this.$refs.AuctionComponent as ModalWrapperComponent).show('Loading auction details...', 'md', dynamicProps);
      return
    }
    const url: string = deal.auction ? deal.auction.getLiveTokenAuctionLink() : deal.getGoneURL()
    window.open(url, "_blank"); 
  }
  public getBuyBidText(deal: Deal) {
    if (deal.flowtyListingResourceID) return 'Flowty'
    return deal.auction ? 'Bid' : "Buy"
  }
  public getGoneText(deal: Deal) {
    if (!deal.auction) {
      const timeInSec: number = Math.floor(deal.goneInSec)
      if (timeInSec <= 0 || new Date().getTime() - deal.dateListed.getTime() > 90 * 1000) return 'Gone'
      return `Gone (${Math.floor(deal.goneInSec)}s)`
    } else {
      return 'Ended'
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

  // for tracking purposes -- don't even bother reading the response
  private async sendDealClick(deal: Deal) {
    // make POST call
    try {
      const url: string = utils.getURLprefix() + '/api/topshot/dealClick';
      const postData: any = { deal } 
      const response: any = await utils.makePostCall(url, postData)
    } catch (error) {
      if (this.$store.state.devmode) console.error(error);
    } finally {
    }
  }

}
